export default __webpack_public_path__ + "static/media/Caveat-VariableFont_wght.31f0a02d.ttf";